<ul class="nav-list">
    @for (item of items; track item.id) {
        <li>
            @if (item.children) {
                <button
                    type="button"
                    class="nav-link"
                    [class.is-active]="isActive(item)"
                    [class.is-disabled]="item.disabled"
                    [attr.aria-expanded]="isExpanded(item)"
                    [attr.aria-disabled]="item.disabled || null"
                    [pTooltip]="item.disabled ? item.disabledHint : undefined"
                    tooltipPosition="right"
                    (click)="toggle(item)">
                    <ng-container *ngTemplateOutlet="entry; context: { $implicit: item }" />
                    <span class="nav-link__chevron material-symbols-outlined icon-md" aria-hidden="true"
                        >expand_more</span
                    >
                </button>
                @if (isExpanded(item)) {
                    <ul class="nav-list nav-list--nested">
                        @for (child of item.children; track child.id) {
                            <li><ng-container *ngTemplateOutlet="link; context: { $implicit: child }" /></li>
                        }
                    </ul>
                }
            } @else {
                <ng-container *ngTemplateOutlet="link; context: { $implicit: item }" />
            }
        </li>
    }
</ul>

<ng-template #link let-item>
    @if (item.disabled) {
        <span
            class="nav-link is-disabled"
            role="link"
            aria-disabled="true"
            tabindex="0"
            [pTooltip]="item.disabledHint"
            tooltipPosition="right">
            <ng-container *ngTemplateOutlet="entry; context: { $implicit: item }" />
        </span>
    } @else if (item.route) {
        <a
            class="nav-link"
            [routerLink]="item.route"
            [class.is-active]="isActive(item)"
            [attr.aria-current]="isActive(item) ? 'page' : null"
            [attr.data-testid]="item.testId"
            (click)="follow(item)">
            <ng-container *ngTemplateOutlet="entry; context: { $implicit: item }" />
        </a>
    } @else {
        <button
            type="button"
            class="nav-link"
            [class.is-active]="isActive(item)"
            [attr.aria-current]="isActive(item) ? 'page' : null"
            [attr.data-testid]="item.testId"
            (click)="follow(item)">
            <ng-container *ngTemplateOutlet="entry; context: { $implicit: item }" />
        </button>
    }
</ng-template>

<ng-template #entry let-item>
    @if (item.icon) {
        <span class="nav-link__icon material-symbols-outlined icon-md" aria-hidden="true">{{ item.icon }}</span>
    }
    <span class="nav-link__label">{{ item.label }}</span>
</ng-template>
